import { render, staticRenderFns } from "./WareHouseMarkCRUD.vue?vue&type=template&id=ce5d0468"
import script from "./WareHouseMarkCRUD.vue?vue&type=script&lang=js"
export * from "./WareHouseMarkCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports